import { css } from 'styled-components';

// Fixed header height and logo height per breakpoint (phone < 600px, tablet 600-1199px, desktop 1200px+).
// Anything that has to clear the fixed header (page body offset, slide-out menu height) reads from here.
export const HEADER_HEIGHT = { phone: 64, tablet: 72, desktop: 90 };
export const LOGO_HEIGHT = { phone: 40, tablet: 48, desktop: 60 };

// Applies `rule(height)` for each breakpoint, e.g. responsiveHeight(HEADER_HEIGHT, h => `height: ${h}px;`)
export const responsiveHeight = (heights, rule) => css`
  ${rule(heights.phone)}

  ${({ theme }) => theme.media.tabletPortraitUp`
    ${rule(heights.tablet)}
  `}

  ${({ theme }) => theme.media.desktopUp`
    ${rule(heights.desktop)}
  `}
`;
